let Category = function (id, name, word) {
    this.id = id || 0;
    this.name = name || '';
    this.word = word || '';
};

export default Category;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/category.js